export enum RedirectType {
  Restricted = 'restricted',
  Inclusive = 'inclusive',
}
